import script from "./countersign.vue?vue&type=script&lang=ts&setup=true"
export * from "./countersign.vue?vue&type=script&lang=ts&setup=true"

import "./countersign.vue?vue&type=style&index=0&id=6ec2b417&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec2b417"]])

export default __exports__